/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2019 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 8/19/2019.
 *
 */

import React from 'react'
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import {Grid} from "@scuf/common"
import Loader from "../common/Loader";
import {fetchNotifications} from "../api/Notifications"
import NotificationsLogTable from "./NotificationsLogTable";

class Notifications extends React.Component {

    constructor() {
        super();
        this.state = {
            loading: false,
            notifications: [],
        }
        this.fetchNotifications = this.fetchNotifications.bind(this)
    }

    componentDidMount() {
        this.fetchNotifications();
    }

    fetchNotifications() {
        this.setState({loading: true});
        const me = this;
        fetchNotifications().then(
            function (response) {
                me.setState({loading: false, notifications: response})
            }
        );
    }

    render() {
        return (
            <div>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={2}/>
                        <Grid.Column width={8} sWidth={12}>
                            <h2><FormattedMessage id="page.notifications"/></h2>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <div className="notifications-table">
                    <Loader loading={this.state.loading}/>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={2}/>
                            <Grid.Column width={8}>
                                <NotificationsLogTable notifications={this.state.notifications}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            </div>
        )
    }
}

export default injectIntl(withRouter(connect()(Notifications)))
